import createVueComponent from '../createVueComponent';
export default createVueComponent('alert-circle', 'IconAlertCircle', [
  ['path', { d: 'M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0', key: 'svg-0' }],
  ['path', { d: 'M12 8v4', key: 'svg-1' }],
  ['path', { d: 'M12 16h.01', key: 'svg-2' }],
]);
